/**
 * `@commerce/theme-sorsy` — theme bundle for Sorsy, the electrical /
 * renewables storefront. Registered under theme id {@code 'sorsy'} in a
 * host's {@code ResolverCatalog} (via {@code registerTheme('sorsy',
 * sorsyTheme)}); resolved by {@link resolveBlock} ahead of the generic
 * {@code @commerce/site-builder-blocks} catalogue for the block types it
 * overrides below.
 *
 * <h3>What ships here</h3>
 * <ul>
 *   <li>{@code KitEnquiryCta} — reskins the generic enquiry CTA into a
 *       full-bleed, phone-forward band. Sorsy's kits (£4-6k renewables
 *       installs) close on a phone call, not a marketplace funnel — see
 *       the "renewables sales are cold outreach" project note — so this
 *       override makes the {@code tel:} link the loudest element on the
 *       page instead of a secondary action beside a button.</li>
 * </ul>
 *
 * <p>Everything NOT overridden here stays canonical: {@code ProductGrid},
 * {@code ProductDetail} and {@code FacetPanel} render as the generic
 * `@commerce/site-builder-blocks` versions, which already read tenant brand
 * tokens (`--color-brand-*`) rather than hardcoding a look — there is
 * nothing Sorsy-specific about a facet checkbox list or a paginated grid.
 *
 * <p>Usage:
 * <pre>{@code
 *   import { sorsyTheme } from '@commerce/theme-sorsy';
 *   import { genericBlocks } from '@akademi/site-builder-blocks';
 *   import { commerceBlocks } from '@commerce/site-builder-blocks';
 *   import { createBlockResolver } from '@akademi/site-builder-runtime';
 *
 *   const resolver = createBlockResolver({
 *     defaultBlocks: { ...genericBlocks, ...commerceBlocks },
 *     themes: { sorsy: sorsyTheme },
 *   });
 * }</pre>
 */
import type { ThemeBundle, BlockComponent } from '@akademi/site-builder-runtime';
import { KitEnquiryCta } from './blocks/KitEnquiryCta';

export { KitEnquiryCta, type KitEnquiryCtaProps } from './blocks/KitEnquiryCta';

export const sorsyTheme: ThemeBundle = {
  blocks: {
    KitEnquiryCta: KitEnquiryCta as unknown as BlockComponent,
  },
  primitives: {},
};
